var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_273_732)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8347 11.797L5.74026 8.23408C6.30158 7.34508 7.31053 6.75 8.44737 6.75H15.5526C16.6895 6.75 17.6913 7.33808 18.2597 8.22708L13.1795 11.783C12.4618 12.252 11.5381 12.252 10.8347 11.797ZM18.7358 9.62007L13.9895 12.9381C13.3784 13.3371 12.6821 13.533 11.9929 13.533C11.3108 13.533 10.6287 13.3371 10.0318 12.9451L5.26422 9.62007C5.25712 9.71107 5.25 9.809 5.25 9.9V14.1C5.25 15.836 6.68526 17.25 8.44737 17.25H15.5526C17.3147 17.25 18.75 15.836 18.75 14.1V9.9C18.75 9.809 18.7429 9.71107 18.7358 9.62007Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_732",
    x1: 26.3567,
    y1: -1.66265,
    x2: -4.0077,
    y2: 4.61494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#4D96B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconSvg);
export default __webpack_public_path__ + "static/media/MessageIconSvg.c4c91e75e928495918ddf50d67269163.svg";
export { ForwardRef as ReactComponent };